module.exports = {
	purge: [
		'./Templates/Designs/**/*.cshtml',
		'./Templates/Designs/**/*.js',
		'./Templates/Designs/**/*.vue'
	],
	theme: {
		colors: {
			'black': '#000000',
			'white': '#ffffff',
			'success': '#3c763d',
			'success-bright': '#4BB543',
			'warning': '#FF7900',
			'background': '#F5F5F5',
			'grey': '#CCCCCC'
		},
		screens: {
			sm: '576px',
			md: '768px',
			lg: '992px',
			xl: '1200px',
		},
		fontSize: {
			xxs: '.625rem',
			xs: '.75rem',
			sm: '.875rem',
			base: '1rem',
			lg: '1.125rem',
			xl: '1.25rem'
		},
		fontWeight: {
			medium: 500,
			semibold: 600,
			bold: 700
		},
		lineHeight: {
			tight: 1.25,
			normal: 1.5
		},
		textColor: theme => theme('colors'),
		backgroundSize: {
			cover: 'cover',
			contain: 'contain'
		},
		borderWidth: {
			DEFAULT: '1px',
			'0': '0',
			'2': '2px',
			'4': '4px',
			'8': '8px',
		},
		borderRadius: {
			none: '0',
			sm: '.125rem',
			DEFAULT: '.25rem',
			lg: '.5rem',
			full: '9999px',
		},
		width: {
			auto: 'auto',
			'50p': '50%',
			'33p': '33.33333%',
			'66p': '66.66667%',
			'25p': '25%',
			'75p': '75%',
			'20p': '20%',
			'40p': '40%',
			'60p': '60%',
			'80p': '80%',
			full: '100%',
		},
		height: {
			auto: 'auto',
			px: '1px',
			full: '100%',
			screen: '100vh',
		},
		minWidth: {
			'0': '0',
			full: '100%',
		},
		minHeight: {
			'0': '0',
			full: '100%',
			screen: '100vh',
		},
		maxWidth: {
			xs: '20rem',
			sm: '30rem',
			md: '40rem',
			lg: '50rem',
			xl: '60rem',
			full: '100%',
		},
		maxHeight: {
			full: '100%',
			screen: '100vh',
		},
		padding: {
			px: '1px',
			'0': '0',
			'1': '0.25rem',
			'2': '0.5rem',
			'3': '0.75rem',
			'4': '1rem',
			'6': '1.5rem',
			'8': '2rem',
			'10': '2.5rem',
			'12': '3rem',
			'14': '3.5rem',
			'16': '4rem',
		},
		margin: {
			auto: 'auto',
			px: '1px',
			'0': '0',
			'1': '0.25rem',
			'2': '0.5rem',
			'3': '0.75rem',
			'4': '1rem',
			'6': '1.5rem',
			'8': '2rem',
			'-1': '-0.25rem',
			'-2': '-0.5rem',
		},
		boxShadow: {
			DEFAULT: '0 2px 4px 0 rgba(0,0,0,0.10)',
			md: '0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08)',
			lg: '0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08)',
			inner: 'inset 0 2px 4px 0 rgba(0,0,0,0.06)',
			none: 'none',
		},
	},
	variants: {
		accessibility: [],
		alignContent: [],
		alignItems: [],
		alignSelf: [],
		appearance: [],
		backgroundAttachment: [],
		backgroundClip: [],
		backgroundColor: [],
		backgroundImage: [],
		gradientColorStops: [],
		backgroundOpacity: [],
		backgroundPosition: [],
		backgroundRepeat: [],
		backgroundSize: [],
		borderCollapse: [],
		borderColor: [],
		borderOpacity: [],
		borderRadius: [],
		borderStyle: [],
		borderWidth: [],
		boxShadow: [],
		boxSizing: [],
		container: [],
		cursor: [],
		display: ['responsive'],
		divideColor: [],
		divideOpacity: [],
		divideStyle: [],
		divideWidth: [],
		fill: [],
		flex: [],
		flexDirection: ['responsive'],
		flexGrow: [],
		flexShrink: [],
		flexWrap: ['responsive'],
		float: [],
		clear: [],
		fontFamily: [],
		fontSize: ['responsive'],
		fontSmoothing: [],
		fontVariantNumeric: [],
		fontStyle: [],
		fontWeight: [],
		height: [],
		inset: ['responsive'],
		justifyContent: ['responsive'],
		justifyItems: [],
    	justifySelf: [],
		letterSpacing: [],
		lineHeight: [],
		listStylePosition: [],
		listStyleType: [],
		margin: ['responsive'],
		maxHeight: [],
		maxWidth: [],
		minHeight: [],
		minWidth: [],
		objectFit: [],
		objectPosition: [],
		opacity: [],
		order: [],
		outline: [],
		overflow: [],
		overscrollBehavior: [],
		padding: ['responsive'],
		placeContent: [],
		placeItems: [],
		placeSelf: [],
		placeholderColor: [],
		placeholderOpacity: [],
		pointerEvents: [],
		position: [],
		resize: [],
		space: [],
		stroke: [],
		strokeWidth: [],
		tableLayout: [],
		textAlign: [],
		textColor: [],
		textOpacity: [],
		textDecoration: [],
		textTransform: [],
		userSelect: [],
		verticalAlign: [],
		visibility: [],
		whitespace: [],
		width: ['responsive'],
		wordBreak: [],
		zIndex: [],
		gap: [],
		gridAutoFlow: [],
		gridTemplateColumns: [],
		gridAutoColumns: [],
		gridColumn: [],
		gridColumnStart: [],
		gridColumnEnd: [],
		gridTemplateRows: [],
		gridAutoRows: [],
		gridRow: [],
		gridRowStart: [],
		gridRowEnd: [],
		transform: [],
		transformOrigin: [],
		scale: [],
		rotate: [],
		translate: [],
		skew: [],
		transitionProperty: [],
		transitionTimingFunction: [],
		transitionDuration: [],
		transitionDelay: [],
		animation: []
	}
}
